import { inject, Injectable } from '@angular/core';
import { type RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { DocumentTitleService } from './document-title.service';

@Injectable({ providedIn: 'root' })
export class MomentumTitleStrategy extends TitleStrategy {
  private readonly documentTitle = inject(DocumentTitleService);

  override updateTitle(routerState: RouterStateSnapshot): void {
    this.documentTitle.apply(routerState, this);
  }
}
